
export default {
  name: "ProductCard",

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    title: function () {
      return this.product?.name
    },
    subtitle: function () {
      return (this.product?.shortCharacteristics || []).find((t) => t.slug === "podzagolovok-dlya-kartochki-tovara-mashiny")?.values?.[0]?.value;
    },
    characteristics: function () {
      let list = (this.product?.shortCharacteristics || []).filter((t) => Boolean(t.show_in_product_card && t.filter_template !== 'hidden'));
      list = list.map((t) => {
        return {
          ...t,
          value: (t?.values || []).map((t) => t?.value).join(", ")
        }
      })

      return list
    }
  }
}
